import { Pipe, PipeTransform } from '@angular/core';
import * as abc from 'number-abbreviate';

@Pipe({
  name: 'numberAbbr'
})
export class NumberAbbr implements PipeTransform {
  transform(value: any): any {
    let newValue = value;
    if (value >= 100000) {
      let numAbbr = new abc([' K', ' Mn', ' Bn', ' Tr']);
      newValue = numAbbr.abbreviate(value, 4);
    }

    return newValue;
  }
}
